var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 541.21 149.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:6.7px;}.cls-1{stroke:#231f20;}.cls-2{stroke:#000;}.cls-3{font-size:65.03px;fill:#231f20;font-family:Gotham-Black, Gotham Black;font-weight:800;letter-spacing:-0.02em;}.cls-4{letter-spacing:-0.04em;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:-0.02em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO Name") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.34 103.14 53.29 34.94 82.82 108.42 82.82 108.42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.34,
    cy: 103.14,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.41,
    cy: 31.1,
    r: 3.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "29.34 103.14 72.21 61.4 107.96 100.23 94.41 31.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.93,
    cy: 74.93,
    r: 71.58
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(182.14 96.68)"
  }, "AN", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 100.14,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 146.83,
    y: 0
  }, "J N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 248.65,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 290.4,
    y: 0
  }, "GI")), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.71,
    y1: 108.18,
    x2: 96.51,
    y2: 141.36
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/LOGO Name.7f96fba93970d34e00ec71820655a204.svg";
export { ForwardRef as ReactComponent };